import CreatePayrollReceipt from './views/Create.vue'
import Validate from './views/ValidateIdentity.vue'
import CreateCertifiedLetters from './views/CreateLettersCertificates.vue'

export const PayrollReceipts = [
  {
    path: '/payroll-receipt',
    name: 'PayrollReceipt',
    component: CreatePayrollReceipt,
    meta: {
      auth: true,
      layout: 'home'
    }
  },
  {
    path: '/payroll-receipt/validate',
    name: 'Validate',
    component: Validate,
    meta: {
      auth: false,
      layout: 'public'
    }
  },
  {
    path: '/certified-letters',
    name: 'CreateCertifiedLetters',
    component: CreateCertifiedLetters,
    meta: {
      auth: true,
      layout: 'home'
    }
  }
]
